export const operationTodayApiGet = (data) => {
    return data.data;
}
export const branchListGet = (data) => {
    return data.data;
}
export const bookingListGet = (data) => {
    return data.data;
}
export const occupancyReportGet = (data) => {
    return data.data;
}
export const activityOverviewReportGet = (data) => {
    return data.data;
}
export const availabilityReportGet = (data) => {
    return data.data;
}
export const revenueReportGet = (data) => {
    return data.data;
}
export const visitorsReportsGet = (data) => {
    return data.data;
}
export const bookingApproveUpdate = (data) => {
    return data.data;
}
export const getPersonDetailsGet = (data) => {
    return data.data;
}
export const roomCheckinCheckoutApi = (data) => {
    return data.data;
}
export const visitorsReportsCsvGet = (data) => {
    return data.data;
}
export const salesDetailsApiGet = (data) => {
    return data.data;
}
export const bookingsIndividualDetailsGet = (data) => {
    return data.data;
}
export const paymentPriceDistributionGet = (data) => {
    return data.data;
}
export const texDetailsApiGet = (data) => {
    return data.data;
}
export const taxRevenueReportGet = (data) => {
    return data.data;
}
export const topSellingLowSellingProductsPost = (data) => {
    return data.data;
}
export const getLowStockProductsGet = (data) => {
    return data.data;
}